import { render } from "./clock-widget.vue?vue&type=template&id=765111ea&scoped=true"
import script from "./clock-widget.vue?vue&type=script&lang=js"
export * from "./clock-widget.vue?vue&type=script&lang=js"

import "./clock-widget.vue?vue&type=style&index=0&id=765111ea&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765111ea"]])

export default __exports__